require('./RAGlobalPosition.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');
const moment = require('moment');

// @commons
const {
    CommercialAdsCCValidated: CommercialAds,
} = require('components/commons/commercialAds/commercialAds');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKModal = require('components/commons/OKModal/OKModal');
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { Portfolios } = require('../../utilities/RAPortfolioHelper');

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const RAAccordionDistributionTable = require('../RAAccordionDistributionTable/RAAccordionDistributionTable');
const RAAlertsWidget = require('../RAAlertsWidget/RAAlertsWidget');
const RADistributionWidget = require('../RADistributionWidget/RADistributionWidget');
const RAPortfolioEvolution = require('../RAPortfolioEvolution/RAPortfolioEvolution');
const RAModalContainer = require('../RAModalContainer/RAModalContainer');
const RAFrontTestPosition = require('../RAFrontTestPosition/RAFrontTestPosition');
const RAServiceInfo = require('../RAServiceInfo/RAServiceInfo');
const RAMessage = require('../RAMessage/RAMessage');
const RANonresidentialModal = require('../RANonresidentialModal/RANonresidentialModal');
const RAFeatureFlagModal = require('../../components/RAFeatureFlagModal/RAFeatureFlagModal');
const {
    BrokerInvestmentSpecialist,
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const RASummaryWidget = require('../RASummaryWidget/RASummaryWidget');
const RADistributionModal = require('../RADistributionModal/RADistributionModal');
const RAGoalNotification = require('../RAGoalNotification/RAGoalNotification');
const RAFundTransferNotification = require('../RAFundTransferNotification/RAFundTransferNotification');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');
const RAGuideLink = require('../RAGuideLink/RAGuideLink');

// @actions
const BrokerConsultMiFIDActions = require('mifid/actions/brokerConsultMiFID');
const raAdditionalContributionActions = require('../../actions/RAAdditionalContribution');
const raGlobalPosition = require('../../actions/RAGlobalPosition');
const raManagementPlanActions = require('../../actions/RAManagementPlan');
const portfolioEvolutionActions = require('../../actions/RAPortfolioEvolution');
const suitabilityActions = require('../../actions/RASuitabilityTest');
const RAAlertsActions = require('../../actions/RAAlerts');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');
const raErrorHandlerActions = require('../../actions/RAErrorHandler');
const raObjectiveDetailsActions = require('../../actions/RAObjectiveDetails');
const raSaveSimulationActions = require('../../actions/RASaveSimulation');
const profileActions = require('actions/profile');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');

// @utilites
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    recordLink,
    recordLinkV2,
    PROC_RA_GLOBAL_POSITION_INTERACTION,
} = require('utilities/tagging');
const RAPortfolioHelper = require('../../utilities/RAPortfolioHelper');
const {
    isTestExpired,
    isTestValid,
} = require('../../utilities/RASuitabilityTestHelper');

// @constants
const {
    TYPE_PLANS,
    ALERTS,
    ESG_PRODUCT,
    MODIFY_SUITABILITY_TEST,
    ROBO_ZERO_COMMISSION,
    PUT_YOUR_MONEY_TO_WORK,
} = require('constants/flagBasedFeatures');
const {
    DISTRIBUTION_MODAL_OPTION_TOTAL,
    GOAL_TRACKING_URL,
    FAQ_URL,
    MANAGEMENT_PLAN_URL,
    MYPROFILE_ROBO_SETGOAL,
    GLOBAL_TRACKING_URL_PARA,
    ORIGIN_COUNTRY_GERMANY,
    PROC_RA_GLOBAL_POSITION_ADITIONAL_CONTRIBUTION,
    PROC_RA_GLOBAL_POSITION_CLOSE_SIMULATION,
    PROC_RA_GLOBAL_POSITION_DISTRIBUTION_MODAL,
    PROC_RA_GLOBAL_POSITION_EDIT_SIMULATION,
    PROC_RA_GLOBAL_POSITION_FAQS,
    PROC_RA_HIRE,
    PROC_RA_GLOBAL_POSITION_NEW_ADITIONAL_CONTRIBUTION,
    PROC_RA_GLOBAL_POSITION_NEW_CONTRIBUTION,
    PROC_RA_GLOBAL_POSITION_NEW_OBJECTIVE,
    PROC_RA_GLOBAL_POSITION_NEW_WALLET,
    PROC_RA_GLOBAL_POSITION_OPTIONS_MENU,
    PROC_RA_GLOBAL_POSITION_ORDERS_AND_MOVEMENTS,
    PROC_RA_GLOBAL_POSITION_RESPONSIBLE_PROFITABILITY,
    PROC_RA_GLOBAL_POSITION_RETURN_TEST,
    PROC_RA_GLOBAL_POSITION_SUITABILITY_TEST,
    PROC_RA_GLOBAL_POSITION_TOP_MENU,
    PROC_RA_ORDERS_AND_MOVEMENTS,
    RA_SUITABILITY_TEST_URL,
    RA_SUITABILITY_TEST_WIDGET,
    RA_LAST_MOVEMENTS_URL,
    OBJECTIVE_TRACK_URL_PARA,
    PORTFOLIO_TRACK_URL_PARA,
    RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER,
    RA_ADDITIONAL_CONTRIBUTION_URL,
    RA_DISASSOCIATE_GOAL_URL,
    SUITABILITY_TEST_URL,
    SUITABILITY_TEST_STATUS_URL,
    RA_SUITABILITY_TEST_HIRE_OPERATION,
    RA_FUND_TRANSFER_STEP1,
    RA_FUND_TRANSFER_STEP2,
    RA_FUND_TRANSFER_STEP3,
    RA_PORTFOLIO_FUND_HIRING_METHOD,
    PROC_RA_DISTRIBUTION_WIDGET_CARD,
    PROC_RA_DISTRIBUTION_WIDGET_TEXT,
    PROC_RA_ACCORDION_DISTRIBUTION_CHEVRON,
    PROC_RA_PORTFOLIO_EVOLUTION_CARD,
    PROC_RA_PORTFOLIO_EVOLUTION_TEXT,
    PROC_RA_GLOBAL_POSITION_HAVE_NO_CONTRACT,
    PROC_RA_GLOBAL_POSITION_HAVE_CONTRACT,
} = require('../../raConstants/index');
const {
    DEFAULT_PORTFOLIO_QUANTITY,
} = require('../../raConstants/RAObjectiveTracking');
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const { RA_GLOBAL_POSITION } = require('utilities/tagging');

// @Contact Center
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const RAObjectiveInfomationNotification = require('../contactCenter/RAObjectiveInfomationNotification/RAObjectiveInfomationNotification');
const RAErrorFetchingCountryOfResidenceModal = require('../contactCenter/RAErrorFetchingCountryOfResidenceModal/RAErrorFetchingCountryOfResidenceModal');

class RAGlobalPosition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isDistributionModalOpened: false,
            showModal: false,
            showGoalNotification: true,
            showFundTransferNotification: true,
            showErrorFetchingCountryOfResidenceModal: false,
            modalTitle: '',
            showGoalNotificationForContactCenter: true,
            showExpiredTest: true,
            showModalTestExpired: false,
            showUnsuitableTestCancelation: true,
        };

        this.handleEmptyEvolutionLinkClick = this.handleEmptyEvolutionLinkClick.bind(
            this,
        );

        this.handleAccordionDistributionTableLink = this.handleAccordionDistributionTableLink.bind(
            this,
        );

        this.onCalculateLinkClick = this.onCalculateLinkClick.bind(this);
        this.handleFeatureModal = this.handleFeatureModal.bind(this);
        this.handleAdditionalContributionClick = this.handleAdditionalContributionClick.bind(
            this,
        );
        this.handleEvolutionChartModalOptionChange = this.handleEvolutionChartModalOptionChange.bind(
            this,
        );
        this.handleModalOptionChange = this.handleModalOptionChange.bind(this);
        this.handleHireClick = this.handleHireClick.bind(this);
        this.handleOptionsClick = this.handleOptionsClick.bind(this);
        this.handleNewContributionRoboOptionsClick = this.handleNewContributionRoboOptionsClick.bind(
            this,
        );
        this.buildDisabledEmptyState = this.buildDisabledEmptyState.bind(this);
        this.handleNewObjectiveClick = this.handleNewObjectiveClick.bind(this);
        this.handleNewStrategyClick = this.handleNewStrategyClick.bind(this);
        this.fetchDataAfterFetchingInvestments = this.fetchDataAfterFetchingInvestments.bind(
            this,
        );
        this.handleGoalNotificationClose = this.handleGoalNotificationClose.bind(
            this,
        );
        this.handleModifyGoalAmountClick = this.handleModifyGoalAmountClick.bind(
            this,
        );
        this.handleReturnTestClick = this.handleReturnTestClick.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.validateResidential = this.validateResidential.bind(this);
        this.handleOpenDistributionModal = this.handleOpenDistributionModal.bind(
            this,
        );
        this.handleCloseDistributionModal = this.handleCloseDistributionModal.bind(
            this,
        );
        this.buildSaveSimulationMessage = this.buildSaveSimulationMessage.bind(
            this,
        );
        this.handleModalExpiredTest = this.handleModalExpiredTest.bind(this);
        this.handleCloseSaveSimulationMessage = this.handleCloseSaveSimulationMessage.bind(
            this,
        );
        this.handleToggleErrorFetchingCountryOfResidenceModal = this.handleToggleErrorFetchingCountryOfResidenceModal.bind(
            this,
        );
        this.handleGoalNotificationCloseForContactCenter = this.handleGoalNotificationCloseForContactCenter.bind(
            this,
        );
        this.handleFundNotificationClose = this.handleFundNotificationClose.bind(
            this,
        );
        this.handleOnEditLinkClick = this.handleOnEditLinkClick.bind(this);
        this.handleCloseModalTestExpired = this.handleCloseModalTestExpired.bind(
            this,
        );
        this.handleModalTestExpiredLink = this.handleModalTestExpiredLink.bind(
            this,
        );
        this.onHandleSaveGoalItemClick = this.onHandleSaveGoalItemClick.bind(
            this,
        );
        this.handleOrdersAndMovementsrecordLink = this.handleOrdersAndMovementsrecordLink.bind(
            this,
        );
        this.handleCloseUnsuitableTest = this.handleCloseUnsuitableTest.bind(
            this,
        );
    }

    componentDidMount() {
        const {
            immBrokerMyInvestments,
            immCheckStatus,
            immSaveSimulation,
            consultMiFID,
            getTestResult,
            requestSaveSimulationLandingMessage,
            requestSimulationObjective,
            requestSimulationPortfolio,
            setOriginRedirection,
            showBrokerGeneralError,
            getHistoricalTest,
            immGlobalPosition,
        } = this.props;
        setOriginRedirection(GLOBAL_TRACKING_URL_PARA);
        requestSimulationObjective();
        requestSimulationPortfolio(true);
        getHistoricalTest();
        consultMiFID();
        const profileId = immSaveSimulation.getIn([
            'saveSimulationPortfolio',
            'newProfile',
        ]);
        const objectiveId = immSaveSimulation.getIn([
            'saveSimulationObjective',
            'name',
        ]);
        if (profileId || objectiveId) {
            //If  profileId or objectiveId is there show save simulation message on landing
            requestSaveSimulationLandingMessage(true);
        }
        if (immBrokerMyInvestments.get('fetchSuccess')) {
            this.fetchDataAfterFetchingInvestments();
        }
        if (
            immCheckStatus.get('checkStatusFetched') &&
            isTestValid(immCheckStatus)
        ) {
            getTestResult();
        }

        if (immBrokerMyInvestments.get('errorReceived')) {
            showBrokerGeneralError();
        }

        if (immGlobalPosition.get('hasRoboHired')) {
            recordLink(
                PROC_RA_GLOBAL_POSITION_INTERACTION,
                PROC_RA_HIRE,
                PROC_RA_GLOBAL_POSITION_HAVE_CONTRACT,
            );
        } else {
            recordLink(
                PROC_RA_GLOBAL_POSITION_INTERACTION,
                PROC_RA_HIRE,
                PROC_RA_GLOBAL_POSITION_HAVE_NO_CONTRACT,
            );
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immBrokerMyInvestments,
            immCheckStatus,
            getTestResult,
            showBrokerGeneralError,
        } = this.props;
        const immBrokerMyInvestmentsPrev = prevProps.immBrokerMyInvestments;
        const immCheckStatusPrev = prevProps.immCheckStatus;
        if (
            immBrokerMyInvestments.get('fetchSuccess') &&
            !immBrokerMyInvestmentsPrev.get('fetchSuccess')
        ) {
            this.fetchDataAfterFetchingInvestments();
        }
        const testIsValid = isTestValid(immCheckStatus);
        const checkStatusIsFetched =
            immCheckStatus.get('checkStatusFetched') &&
            !immCheckStatusPrev.get('checkStatusFetched');
        if (checkStatusIsFetched && testIsValid) {
            getTestResult();
        }

        if (immBrokerMyInvestments.get('errorReceived')) {
            showBrokerGeneralError();
        }
    }

    fetchDataAfterFetchingInvestments() {
        const {
            immGlobalPosition,
            requestPortfolioEvolutionTotals,
        } = this.props;
        if (immGlobalPosition.get('hasRoboHired')) {
            const portfolioStartDate = immGlobalPosition.getIn([
                'roboAdvisor',
                'oldestCreated',
            ]);
            requestPortfolioEvolutionTotals(portfolioStartDate);
        }
    }

    handleModalOptionChange(ev) {
        const selectedValue = ev ? ev.value : DISTRIBUTION_MODAL_OPTION_TOTAL;
        this.props.setSelectedPortfolio(selectedValue);
    }

    handleEvolutionChartModalOptionChange(portfolio) {
        const {
            immGlobalPosition,
            evolutionChartChangeModalOption,
            requestPortfolioEvolution,
        } = this.props;
        const startDate = immGlobalPosition.getIn([
            'portfolios',
            portfolio.value,
            'created',
        ]);
        evolutionChartChangeModalOption(portfolio.value);
        if (portfolio.label !== 'Todas') {
            requestPortfolioEvolution(portfolio.value, startDate);
        }
    }

    handleFeatureModal(link) {
        const { history, immRAFeatureFlag } = this.props;
        if (!immRAFeatureFlag.get('purchase')) {
            this.props.featureModalToggle();
        } else {
            history.push(link);
        }
    }

    handleHireClick() {
        const {
            immCheckStatus,
            immFlagBasedFeatures,
            immRAFeatureFlag,
        } = this.props;
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_HIRE,
            PROC_RA_GLOBAL_POSITION_TOP_MENU,
        );
        const resident = this.props.immProfile.get('paisResidencia');
        const originCountry = this.props.immProfile.get('originCountry');
        if (!immRAFeatureFlag.get('purchase')) {
            this.props.featureModalToggle();
        } else if (resident !== originCountry) {
            this.setState({ showNonResidentModal: true });
        } else {
            const actionLinkUrl =
                isTestValid(immCheckStatus) &&
                !immCheckStatus.get('nonSuitableTest')
                    ? MANAGEMENT_PLAN_URL
                    : RA_SUITABILITY_TEST_URL;
            if (
                immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST) &&
                isTestExpired(immCheckStatus)
            ) {
                this.setState({ showModalTestExpired: true });
            } else {
                this.props.history.push(actionLinkUrl);
            }
        }
    }

    handleOptionsClick(eventAction) {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_OPTIONS_MENU,
            eventAction,
        );
    }

    handleNewContributionRoboOptionsClick() {
        const { immRAFeatureFlag } = this.props;
        this.handleOptionsClick(PROC_RA_GLOBAL_POSITION_NEW_CONTRIBUTION);
        if (
            !immRAFeatureFlag.get('recurringContribution') &&
            !immRAFeatureFlag.get('additionalContribution')
        ) {
            this.props.featureModalToggle();
        } else {
            this.props.history.push(RA_ADDITIONAL_CONTRIBUTION_URL);
        }
    }

    handleNewObjectiveClick() {
        this.validateResidential(MYPROFILE_ROBO_SETGOAL);
    }

    handleNewStrategyClick() {
        this.validateResidential(MANAGEMENT_PLAN_URL);
    }

    validateResidential(path) {
        const {
            immCheckStatus,
            immRAFeatureFlag,
            immProfile,
            immFlagBasedFeatures,
        } = this.props;
        const resident = immProfile.get('paisResidencia');
        const originCountry = immProfile.get('originCountry');
        if (resident !== originCountry) {
            this.setState({
                showModal: true,
                modalTitle: formatText(
                    'raNonresidentialModal-titleNonObjective',
                ),
            });
        } else {
            if (immProfile.get('error')) {
                this.setState({
                    showErrorFetchingCountryOfResidenceModal: true,
                });
                return;
            }
            if (!immRAFeatureFlag.get('purchase')) {
                this.props.featureModalToggle();
            } else {
                if (isTestValid(immCheckStatus)) {
                    this.props.history.push(path);
                } else if (
                    immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST) &&
                    isTestExpired(immCheckStatus) &&
                    path != RA_SUITABILITY_TEST_WIDGET
                ) {
                    this.setState({ showModalTestExpired: true });
                } else {
                    this.props.history.push(RA_SUITABILITY_TEST_URL);
                }
            }
        }
    }

    handleGoalNotificationClose() {
        this.setState({
            showGoalNotification: false,
        });
    }

    handleModifyGoalAmountClick(id) {
        const url = `${GOAL_TRACKING_URL}/${id}`;
        this.props.setFromPGNotification();
        this.props.history.push(url);
    }

    handleReturnTestClick() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_RETURN_TEST,
        );
        this.props.history.push(RA_SUITABILITY_TEST_URL);
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal,
        });
    }

    handleToggleErrorFetchingCountryOfResidenceModal() {
        this.props.requestProfile(true);
        this.setState({
            showErrorFetchingCountryOfResidenceModal: !this.state
                .showErrorFetchingCountryOfResidenceModal,
        });
    }

    validateResidentialType(type) {
        const { immCheckStatus, immFlagBasedFeatures, immProfile } = this.props;
        if (__CONTACT_CENTER__ && immProfile.get('error')) {
            this.setState({
                showErrorFetchingCountryOfResidenceModal: true,
            });
            return;
        }

        const resident = immProfile.get('paisResidencia');
        const originCountry = immProfile.get('originCountry');

        let message;
        if (resident !== originCountry) {
            this.setState({ showModal: true });
            if (type === 'goal') {
                message = formatText('raNonresidentialModal-titleObjective');
            } else {
                message = formatText('raNonresidentialModal-titleNonObjective');
            }
            this.setState({ modalTitle: message });
        } else {
            const isGoal = type === 'goal';
            const hireUrl = `/myprofile/robo/${
                isGoal ? 'setGoal' : 'management'
            }`;
            const url = isTestValid(immCheckStatus)
                ? hireUrl
                : RA_SUITABILITY_TEST_URL;
            if (type === 'esg') {
                recordLink(
                    PROC_RA_GLOBAL_POSITION_INTERACTION,
                    PROC_RA_HIRE,
                    PROC_RA_GLOBAL_POSITION_RESPONSIBLE_PROFITABILITY,
                );
            } else {
                const eventAction = isGoal
                    ? PROC_RA_GLOBAL_POSITION_NEW_OBJECTIVE
                    : PROC_RA_GLOBAL_POSITION_NEW_WALLET;
                recordLink(PROC_RA_GLOBAL_POSITION_INTERACTION, eventAction);
            }
            if (
                immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST) &&
                isTestExpired(immCheckStatus)
            ) {
                this.setState({ showModalTestExpired: true });
            } else {
                this.props.history.push(url);
            }
        }
    }

    buildServiceBanner() {
        const {
            immGlobalPosition,
            flagBasedFeatures,
            immVariables,
            immCheckStatus,
        } = this.props;
        const showRobo = flagBasedFeatures.get('robo-enabled');
        const hasRoboHired = immGlobalPosition.get('hasRoboHired');
        const commisionFlag =
            flagBasedFeatures.get(ROBO_ZERO_COMMISSION) &&
            immCheckStatus.get('zeroCommission');
        return (
            <div className="col-md-12">
                <RAServiceInfo
                    commisionFlag={commisionFlag}
                    serviceIsDisabled={!showRobo}
                    validateResidential={link => this.validateResidential(link)}
                    immCheckStatus={immCheckStatus}
                    hasRoboHired={hasRoboHired}
                    immVariables={immVariables}
                />
            </div>
        );
    }

    handleGoalNotificationCloseForContactCenter() {
        this.setState({
            showGoalNotificationForContactCenter: false,
        });
    }

    buildTestInfo() {
        const {
            immManagementPlan,
            immSuitabilityTest,
            immCheckStatus,
            immFlagBasedFeatures,
            immRAGlobalPosition,
        } = this.props;
        let investProfile = immManagementPlan.get('investProfileDescription');
        if (isTestValid(immCheckStatus)) {
            investProfile = immSuitabilityTest.getIn([
                'results',
                0,
                'clientRiskProfileTitle',
            ]);
        }

        return (
            <RAFrontTestPosition
                immFlagBasedFeatures={immFlagBasedFeatures}
                immRAGlobalPosition={immRAGlobalPosition}
                immCheckStatus={immCheckStatus}
                investProfile={investProfile}
                onReturnTestClick={this.handleReturnTestClick}
                validateResidential={this.validateResidential}
            />
        );
    }

    buildDisabledEmptyState() {
        const serviceInfo = this.buildServiceBanner();
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-8">
                        <div className="row">
                            <div className="col-md-12 grid-view--fix-cell-separation">
                                {serviceInfo}
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="row">
                            <div className="col-md-12 grid-view--fix-cell-separation">
                                <BrokerInvestmentSpecialist />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildCancelledBox() {
        const message = (
            <div className="col-xs-12">
                <RAMessage
                    title={formatText(
                        'raPortfolioDistribution-cancellationTitle',
                    )}
                >
                    <p>
                        <FormattedText value="raPortfolioDistribution-cancellationMessage" />
                        <FormattedText
                            className="ra-global-position--bold"
                            value="raPortfolioDistribution-cancellationDocs"
                        />
                    </p>
                </RAMessage>
            </div>
        );

        return message;
    }

    buildUnsuitableTestCancelationBox() {
        const { showUnsuitableTestCancelation } = this.state;
        const link = (
            <OKLink onClick={this.handleReturnTestClick}>
                <FormattedText value="raGlobalPosition-raGlobalPosition_unsuitableTestNotificationLinkText" />
            </OKLink>
        );
        return (
            <OKMessage
                type="informative"
                modifier="dark-bg"
                closeButton
                visible={showUnsuitableTestCancelation}
                onCloseButtonClick={this.handleCloseUnsuitableTest}
            >
                <FormattedTextWithComponents
                    value="raGlobalPosition-raGlobalPosition_unsuitableTestNotificationContent"
                    injectedComponents={[link]}
                />
            </OKMessage>
        );
    }

    handleOpenDistributionModal() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_DISTRIBUTION_MODAL,
        );
        this.setState({ isDistributionModalOpened: true });
    }

    handleCloseDistributionModal() {
        this.setState({ isDistributionModalOpened: false });
    }

    buildComponentAd(type) {
        const className = `ra-global-position__ad ra-global-position__ad-${type}`;
        let buttonProps;
        let adTitle;
        let adDescription;
        let adButton;
        let adWrapperClass = 'ra-global-position__ad-wrapper';
        let adTitleClass = 'ra-global-position__ad-title';
        let adDescriptionClass = 'ra-global-position__ad-description';
        if (type === 'goal') {
            adTitle = 'raGlobalPosition-raGlobalPosition_goalAdTitle';
            adDescription =
                'raGlobalPosition-raGlobalPosition_goalAdDescription';
            adButton = 'raGlobalPosition-raGlobalPosition_goalAdButton';
            buttonProps = {
                onClick: () => this.validateResidentialType(type),
            };
        } else if (type === 'esg') {
            adTitle = 'raGlobalPosition-raGlobalPosition_esgAdTitle';
            adDescription =
                'raGlobalPosition-raGlobalPosition_esgAdDescription';
            adButton = 'raGlobalPosition-raGlobalPosition_esgAdButton';
            adWrapperClass = 'ra-global-position__ad-wrapper-esg';
            adTitleClass = 'ra-global-position__ad-title-esg';
            adDescriptionClass = 'ra-global-position__ad-description-esg';
            buttonProps = {
                onClick: () => this.validateResidentialType(type),
            };
        } else {
            adTitle = 'raGlobalPosition-raGlobalPosition_portfolioAdTitle';
            adDescription =
                'raGlobalPosition-raGlobalPosition_portfolioAdDescription';
            adButton = 'raGlobalPosition-raGlobalPosition_portfolioAdButton';
            buttonProps = {
                to: formatText(
                    'raGlobalPosition-raGlobalPosition_portfolioAdButtonURL',
                ),
                onClick: () => {
                    recordLinkV2({
                        categoriaEvento: `espacio comercial ${type}`,
                        accionEvento: 'click',
                        eventLabel: 'saber mas',
                    });
                    this.props.resetSpecificProduct(type.toUpperCase());
                },
            };
        }

        return (
            <div className={className}>
                <div className={adWrapperClass}>
                    <p className={adTitleClass}>
                        <FormattedText value={adTitle} />
                    </p>
                    <p className={adDescriptionClass}>
                        <FormattedText value={adDescription} />
                    </p>
                    <OKButton {...buttonProps}>
                        <FormattedText value={adButton} />
                    </OKButton>
                </div>
            </div>
        );
    }

    buildSummaryWidgetEmptyState() {
        const { flagBasedFeatures } = this.props;
        return (
            <div>
                {flagBasedFeatures.get(ESG_PRODUCT)
                    ? this.buildComponentAd('esg')
                    : this.buildComponentAd('goal')}
                <FeatureTogglingRender notAllowedProductKey={TYPE_PLANS}>
                    <div className="grid-view--fix-cell-separation">
                        {this.buildComponentAd('plans')}
                    </div>
                </FeatureTogglingRender>
            </div>
        );
    }

    handleAdditionalContributionClick() {
        const { immRAFeatureFlag } = this.props;
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_ADITIONAL_CONTRIBUTION,
            PROC_RA_GLOBAL_POSITION_NEW_ADITIONAL_CONTRIBUTION,
        );
        if (
            !immRAFeatureFlag.get('recurringContribution') &&
            !immRAFeatureFlag.get('additionalContribution')
        ) {
            this.props.featureModalToggle();
        } else {
            this.props.history.push(RA_ADDITIONAL_CONTRIBUTION_URL);
        }
    }

    buildRoboOptions(isContactCenterOptions, immPortfolios) {
        const { immCheckStatus } = this.props;
        let moreOptions;
        if (isContactCenterOptions) {
            moreOptions = [
                {
                    link: SUITABILITY_TEST_STATUS_URL,
                    text: formatText(
                        'broker-globalPositionRAPopOverSuitabilityTest',
                    ),
                },
            ];
        } else {
            const immActivePortfolios = immPortfolios.filter(
                immPortfolio => !immPortfolio.getIn(['state', 'cancelled']),
            );
            const immGoals = RAPortfolioHelper.filterByGoals(
                immActivePortfolios,
            );
            const immGoalDatesExpired = immGoals.filter(immGoal =>
                moment(
                    immGoal.getIn(['goalInformation', 'goalDate']),
                ).isSameOrBefore(moment(), 'day'),
            );
            const nonSuitableTest = immCheckStatus.get('nonSuitableTest');
            const testOptionLink = nonSuitableTest
                ? SUITABILITY_TEST_URL
                : SUITABILITY_TEST_STATUS_URL;

            const hasGoalsInProgress =
                immActivePortfolios.size > immGoalDatesExpired.size;

            moreOptions = [
                {
                    handleClick: this.handleNewContributionRoboOptionsClick,
                    visible: this.isAnyPortfolioActive() && hasGoalsInProgress,
                    text: formatText(
                        'raNewContribution-raNewContribution_makeNewContribution',
                    ),
                },
                {
                    handleClick: () => {
                        this.handleOptionsClick(
                            PROC_RA_GLOBAL_POSITION_ORDERS_AND_MOVEMENTS,
                        );
                    },
                    link: RA_LAST_MOVEMENTS_URL,
                    text: formatText('broker-globalPositionRAPopOverMovements'),
                },
                {
                    handleClick: () => {
                        this.handleOptionsClick(
                            PROC_RA_GLOBAL_POSITION_ORDERS_AND_MOVEMENTS,
                        );
                    },
                    link: MANAGEMENT_PLAN_URL,
                    text: formatText(
                        'broker-globalPositionRAPopOverHirePortfolio',
                    ),
                },
                {
                    handleClick: () => {
                        this.handleOptionsClick(
                            PROC_RA_GLOBAL_POSITION_SUITABILITY_TEST,
                        );
                    },
                    link: testOptionLink,
                    text: formatText(
                        'broker-globalPositionRAPopOverSuitabilityTest',
                    ),
                },
                {
                    handleClick: () => {
                        this.handleOptionsClick(PROC_RA_GLOBAL_POSITION_FAQS);
                    },
                    link: FAQ_URL,
                    text: formatText('broker-globalPositionRAFaq'),
                },
            ];
        }

        const targetElement = (
            <OKButton
                modifier="ghost"
                rightIcon="icon-dropdown-abrir"
                smallRightIcon={true}
            >
                <FormattedText value="raGlobalPosition-raGlobalPosition_popOverMenuText" />
            </OKButton>
        );

        return (
            <PopoverMenu
                target={targetElement}
                items={moreOptions}
                placement="bottomRight"
            />
        );
    }

    buildHeaderActionButtons(immCheckStatus, immGlobalPosition) {
        let moreOptions;
        const isCTADisabled = immGlobalPosition.getIn([
            'roboAdvisor',
            'maxAccountsReached',
        ]);
        if (
            immGlobalPosition.get('hasRoboHired') &&
            !immGlobalPosition.get('hasRoboCancelled')
        ) {
            const immPortfolios = immGlobalPosition.get('portfolios');
            moreOptions = this.buildRoboOptions(false, immPortfolios);
        } else if (
            __CONTACT_CENTER__ &&
            immCheckStatus.get('checkStatusFetched') &&
            isTestValid(immCheckStatus)
        ) {
            moreOptions = this.buildRoboOptions(true);
        }

        return (
            <div className="col-xs-12 col-sm-12 col-md-12 grid-view--variable-cell-separation">
                <div className="ra-global-position__side-buttons-group">
                    {moreOptions}
                    <div className="ra-global-position__side-button-right">
                        <OKButton
                            onClick={this.handleHireClick}
                            disabled={isCTADisabled}
                        >
                            <FormattedText value="broker-buySellRoboBtn" />
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    buildAdditionalContributionButton(disabled) {
        return (
            <div className="ra-global-position__contributions-button ra-global-position__contributions-contributions">
                <OKButton
                    modifier="ghost"
                    onClick={this.handleAdditionalContributionClick}
                    disabled={disabled}
                >
                    <FormattedText value="raNewContribution-raNewContribution_makeNewContribution" />
                </OKButton>
            </div>
        );
    }

    buildNewContributionsComponent(anyPortfolioActive, immPortfolios) {
        const immActivePortfolios = immPortfolios.filter(
            immPortfolio => !immPortfolio.getIn(['state', 'cancelled']),
        );
        const purePortfolios = RAPortfolioHelper.filterPurePortfolios(
            immActivePortfolios,
        );
        const goals = RAPortfolioHelper.filterByGoals(immActivePortfolios);
        let onlyGoalsReachedOnDate = false;
        let descriptionKey;
        let disassociateGoalLink;

        if (purePortfolios.isEmpty()) {
            onlyGoalsReachedOnDate = goals.every(goal => {
                const goalProgress = goal.getIn([
                    'goalInformation',
                    'goalProgress',
                ]);
                const goalDate = goal.getIn(['goalInformation', 'goalDate']);

                return (
                    goalProgress >= 1 &&
                    moment(goalDate).isSameOrBefore(moment(), 'day')
                );
            });
        }

        const immGoalsReachedOnDate = goals.filter(goal => {
            const goalProgress = goal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            const goalDate = goal.getIn(['goalInformation', 'goalDate']);

            return (
                goalProgress >= 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day')
            );
        });

        const immNonReachedGoals = goals.filter(goal => {
            const goalProgress = goal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            const goalDate = goal.getIn(['goalInformation', 'goalDate']);

            return (
                goalProgress < 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day')
            );
        });

        const onlyGoalsNonReached =
            immNonReachedGoals.size === immActivePortfolios.size;
        const onlyCombinedGoalsNonReachedBeforeDate =
            immGoalsReachedOnDate.size + immNonReachedGoals.size ===
            immActivePortfolios.size;
        const contributionTextClassName = classnames(
            'ra-global-position__contributions-text',
            {
                'ra-global-position__contributions-text--large':
                    onlyGoalsNonReached ||
                    onlyCombinedGoalsNonReachedBeforeDate,
            },
        );

        if (onlyGoalsReachedOnDate) {
            descriptionKey =
                'raObjectiveTracking-raObjectiveTracking_contributionsNoMore';
        } else if (
            onlyGoalsNonReached ||
            onlyCombinedGoalsNonReachedBeforeDate
        ) {
            const onlyOneGoalNonReached = immNonReachedGoals.size === 1;
            const immGoal = immNonReachedGoals.first();
            const id = immGoal.get('id');
            const disassociateGoalURL = `${RA_DISASSOCIATE_GOAL_URL}/${id}`;
            const descriptionPartialKey = onlyOneGoalNonReached
                ? 'contributionsNotReached'
                : 'contributionsSeveralNotReached';
            descriptionKey = `raGlobalPosition-raGlobalPosition_${descriptionPartialKey}`;
            disassociateGoalLink = onlyOneGoalNonReached && (
                <OKLink to={disassociateGoalURL} modifier="widget">
                    <FormattedText value="raGlobalPosition-raGlobalPosition_contributionsDissociateLink" />
                </OKLink>
            );
        } else {
            descriptionKey = 'raNewContribution-raNewContribution_description';
        }

        const disableCTA = anyPortfolioActive || onlyGoalsReachedOnDate;
        const contributionButton =
            !onlyGoalsNonReached && !onlyCombinedGoalsNonReachedBeforeDate
                ? this.buildAdditionalContributionButton(disableCTA)
                : null;

        return (
            <div className="col-md-12 grid-view--fix-cell-separation">
                <div className="ra-global-position__contributions">
                    <div className="ra-global-position__contributions-body">
                        <i className="icon-incremento-moderado ra-global-position__contributions-icon" />
                        <div className={contributionTextClassName}>
                            <div className="ra-global-position__contributions-title">
                                <FormattedText value="raNewContribution-raNewContribution_title" />
                            </div>
                            <p className="ra-global-position__contributions-description">
                                <FormattedText value={descriptionKey} />
                            </p>
                            {disassociateGoalLink}
                        </div>
                    </div>
                    {contributionButton}
                </div>
            </div>
        );
    }

    buildFeatureModal() {
        const { immRAFeatureFlag, featureModalToggle } = this.props;
        return (
            <RAFeatureFlagModal
                immRAFeatureFlag={immRAFeatureFlag}
                featureModalToggle={featureModalToggle}
            />
        );
    }

    buildGoalNotification(immPortfolios) {
        const immGoals = RAPortfolioHelper.filterByGoals(immPortfolios);

        return (
            <RAGoalNotification
                immGoals={immGoals}
                onModifyAmountClick={this.handleModifyGoalAmountClick}
                onClose={this.handleGoalNotificationClose}
            />
        );
    }

    handleCloseSaveSimulationMessage() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_CLOSE_SIMULATION,
        );
        this.props.requestSaveSimulationLandingMessage(false);
    }

    handleOnEditLinkClick(link) {
        const {
            immCheckStatus,
            immFlagBasedFeatures,
            setEditClicked,
        } = this.props;
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_GLOBAL_POSITION_EDIT_SIMULATION,
        );
        if (
            immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST) &&
            isTestExpired(immCheckStatus)
        ) {
            this.setState({ showModalTestExpired: true });
        } else {
            setEditClicked();
            this.props.history.push(link);
        }
    }

    buildSaveSimulationEditDataLink(link) {
        return (
            <OKLink onClick={() => this.handleOnEditLinkClick(link)}>
                <FormattedText value="raGlobalPosition-raGlobalPosition_savedSimulationEditTextLink" />
            </OKLink>
        );
    }

    buildExpiredTestLink() {
        return (
            <OKLink to={RA_SUITABILITY_TEST_URL}>
                <FormattedText value="raGlobalPosition-raGlobalPosition_testExpiredLink" />
            </OKLink>
        );
    }

    handleModalExpiredTest() {
        this.setState({
            showExpiredTest: false,
        });
    }

    handleCloseUnsuitableTest() {
        this.setState({
            showUnsuitableTestCancelation: false,
        });
    }

    buildTestExpired() {
        const testExpiredLink = this.buildExpiredTestLink();
        const { showExpiredTest } = this.state;
        const testExpiredText = (
            <FormattedTextWithComponents
                value={'raGlobalPosition-raGlobalPosition_testExpiredText'}
                injectedComponents={[testExpiredLink]}
            />
        );

        return (
            <OKMessage
                type="informative"
                modifier="dark-bg"
                closeButton
                visible={showExpiredTest}
                onCloseButtonClick={this.handleModalExpiredTest}
            >
                {testExpiredText}
            </OKMessage>
        );
    }

    buildSaveSimulationMessage() {
        const { immSaveSimulation } = this.props;
        const errorMsgForPortfolio = immSaveSimulation.getIn([
            'saveSimulationPortfolio',
            'error',
        ]);
        const errorMsgForObjective = immSaveSimulation.getIn([
            'saveSimulationObjective',
            'error',
        ]);
        const profileId =
            !errorMsgForPortfolio &&
            immSaveSimulation.getIn(['saveSimulationPortfolio', 'newProfile']);
        const objectiveId =
            !errorMsgForObjective &&
            immSaveSimulation.getIn(['saveSimulationObjective', 'name']);

        if (!profileId && !objectiveId) {
            return;
        }
        const strategy = Portfolios[profileId];
        const typeOfStategy = objectiveId
            ? objectiveId
            : strategy && strategy.portfolioName;
        const redirectionLink = objectiveId
            ? MYPROFILE_ROBO_SETGOAL
            : MANAGEMENT_PLAN_URL;
        const textValue = objectiveId
            ? 'raGlobalPosition-raGlobalPosition_savedSimulationObjectivoText'
            : 'raGlobalPosition-raGlobalPosition_savedSimulationPortfolioText';
        const saveSimulationEditDataLink = this.buildSaveSimulationEditDataLink(
            redirectionLink,
        );
        let savedTextMsg;
        const strategyGoalNameComponent = (
            <span className="ra-save-simulation-modal__description-bold">
                {typeOfStategy}
            </span>
        );

        if (profileId && objectiveId) {
            savedTextMsg = (
                <FormattedText value="raGlobalPosition-raGlobalPosition_savedSimulationInfoText" />
            );
        } else {
            savedTextMsg = (
                <FormattedTextWithComponents
                    value={textValue}
                    injectedComponents={[
                        strategyGoalNameComponent,
                        saveSimulationEditDataLink,
                    ]}
                />
            );
        }

        return (
            <OKMessage
                type="informative"
                modifier="dark-bg"
                closeButton={true}
                onCloseButtonClick={this.handleCloseSaveSimulationMessage}
            >
                {savedTextMsg}
            </OKMessage>
        );
    }

    isAnyPortfolioActive() {
        const { immGlobalPosition } = this.props;
        const activePotfolioList = immGlobalPosition
            .get('portfolios')
            .filter(portfolio => {
                return !portfolio.getIn(['state', 'cancelled']);
            });
        return activePotfolioList.size > 0;
    }

    buildNotificationForCC() {
        const { immGlobalPosition, immProfile } = this.props;
        const immPortfolios = immGlobalPosition.get('portfolios');
        const goalData = RAPortfolioHelper.filterByGoals(immPortfolios);
        const userName = immProfile.get('fullname');
        return (
            <RAObjectiveInfomationNotification
                goalData={goalData}
                userName={userName}
                onClose={this.handleGoalNotificationCloseForContactCenter}
                onModifyAmountClick={this.handleModifyGoalAmountClick}
            />
        );
    }

    handleFundNotificationClose() {
        this.setState({
            showFundTransferNotification: false,
        });
    }

    buildFundTransferNotification() {
        const { immGlobalPosition, immProfile } = this.props;
        const filteredPortfolios = immGlobalPosition
            .get('portfolios')
            .filter(
                portfolio =>
                    portfolio.get('hiringMethod') ===
                        RA_PORTFOLIO_FUND_HIRING_METHOD &&
                    !portfolio.getIn([
                        'state',
                        'fundsTransferStepsWidgetClosed',
                    ]),
            );
        let currentStep = 0;
        if (filteredPortfolios.size > 0) {
            const firstPortfolioWithFund = filteredPortfolios.first();
            const singlePortfolio = filteredPortfolios.size === 1;
            const isNotificationClosed = firstPortfolioWithFund.get(
                'isNotificationClosed',
            );
            const hasGoal = firstPortfolioWithFund.get('hasGoal');
            const portfolioId = firstPortfolioWithFund.get('id');
            const userName = immProfile.get('fullname');
            const movementLink = hasGoal
                ? `${RA_LAST_MOVEMENTS_URL}/${OBJECTIVE_TRACK_URL_PARA}/${portfolioId}`
                : `${RA_LAST_MOVEMENTS_URL}/${PORTFOLIO_TRACK_URL_PARA}/${portfolioId}`;
            let content;
            if (singlePortfolio && !isNotificationClosed) {
                const funded = firstPortfolioWithFund.getIn([
                    'state',
                    'funded',
                ]);
                const fullyFunded = firstPortfolioWithFund.getIn([
                    'state',
                    'fullyFunded',
                ]);
                if (!funded && !fullyFunded) {
                    currentStep = RA_FUND_TRANSFER_STEP1;
                } else if (funded && !fullyFunded) {
                    currentStep = RA_FUND_TRANSFER_STEP2;
                } else if (funded && fullyFunded) {
                    currentStep = RA_FUND_TRANSFER_STEP3;
                }
                content = (
                    <RAFundTransferNotification
                        onClose={this.handleFundNotificationClose}
                        currentStep={currentStep}
                        movementLink={movementLink}
                        userName={userName}
                        closeNotification={
                            this.props.setSinglePortfolioNotificationClosed
                        }
                        disableNotification={
                            this.props.setSinglePortfolioNotificationDisabled
                        }
                        portfolioId={
                            singlePortfolio && firstPortfolioWithFund.get('id')
                        }
                    />
                );
            } else if (!singlePortfolio) {
                content = (
                    <RAFundTransferNotification
                        onClose={this.handleFundNotificationClose}
                        forSinglePortfolio={singlePortfolio}
                        movementLink={movementLink}
                        userName={userName}
                    />
                );
            }
            return content;
        }
    }

    handleModalTestExpiredLink() {
        const { setOrigin } = this.props;
        setOrigin(RA_SUITABILITY_TEST_HIRE_OPERATION);
        this.props.history.push(RA_SUITABILITY_TEST_URL);
    }

    handleCloseModalTestExpired() {
        this.setState({ showModalTestExpired: false });
    }

    buildTestExpiredModal() {
        const { showModalTestExpired } = this.state;
        const content = (
            <FormattedText value="modalTestExpired-modalTestExpired_contentDescription" />
        );
        const title = (
            <FormattedText value="modalTestExpired-modalTestExpired_titleDescription" />
        );
        const button = (
            <div className="ra-global-position__modal-button">
                <OKButton onClick={this.handleModalTestExpiredLink}>
                    <FormattedText value="modalTestExpired-modalTestExpired_buttonDescription" />
                </OKButton>
            </div>
        );
        return (
            <OKModal
                isOpen={showModalTestExpired}
                shouldCloseOnOverlayClick={false}
                description={content}
                descriptionAlignment="center"
                title={title}
                titleAlignment="center"
                primaryButtonCustom={button}
                footerType="action"
                onCloseCallback={this.handleCloseModalTestExpired}
            />
        );
    }

    onHandleSaveGoalItemClick(link) {
        const { immCheckStatus, immFlagBasedFeatures } = this.props;
        if (
            immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST) &&
            isTestExpired(immCheckStatus)
        ) {
            this.setState({ showModalTestExpired: true });
        } else {
            this.props.history.push(link);
        }
    }

    handleOrdersAndMovementsrecordLink() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_ORDERS_AND_MOVEMENTS,
        );
    }

    onCalculateLinkClick() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_DISTRIBUTION_WIDGET_CARD,
            PROC_RA_DISTRIBUTION_WIDGET_TEXT,
        );
    }

    handleAccordionDistributionTableLink(assetClassName) {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_ACCORDION_DISTRIBUTION_CHEVRON,
            assetClassName,
        );
    }

    handleEmptyEvolutionLinkClick() {
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_PORTFOLIO_EVOLUTION_CARD,
            PROC_RA_PORTFOLIO_EVOLUTION_TEXT,
        );
    }

    buildGuideLinkSection() {
        const { immGlobalPosition } = this.props;
        const immPortfolios = immGlobalPosition.get('portfolios');
        if (immPortfolios.size > 0) {
            return (
                <div className="col-xs-12 col-sm-12 col-md-12 grid-view--fix-cell-separation">
                    <RAGuideLink />
                </div>
            );
        }
    }

    render() {
        const {
            flagBasedFeatures,
            fetchAlerts,
            immBrokerCustomWalletPortfolios,
            immBrokerMyInvestments,
            immCheckStatus,
            immGlobalPosition,
            immManagementPlan,
            immPortfolioDistribution,
            immPortfolioEvolution,
            immProfile,
            immSimulation,
            immBrokerCustomWalletInvestments,
            immWalletCharts,
            immFlagBasedFeatures,
        } = this.props;

        const showRobo = flagBasedFeatures.get('robo-enabled');

        if (!showRobo) {
            return this.buildDisabledEmptyState();
        }
        let pgFetched = immBrokerMyInvestments.get('fetchSuccess');
        if (!immWalletCharts.getIn(['defaultView', 'isGeneralView'])) {
            pgFetched = immBrokerCustomWalletInvestments.get('fetchSuccess');
        }
        if (immBrokerCustomWalletPortfolios.get('isFetching') || !pgFetched) {
            return <LoadingSection />;
        }

        const immRoboAdvisor = immGlobalPosition.get('roboAdvisor');
        const immAssetAllocations =
            immRoboAdvisor && immRoboAdvisor.get('assetAllocation');
        const hasRoboHired = immGlobalPosition.get('hasRoboHired');
        const evolutionChartData = immPortfolioEvolution.get('data').toJS();
        const evolutionChartLoading = immPortfolioEvolution.get('isFetching');
        const evolutionChartSelectedOption = immPortfolioEvolution.get(
            'selectedOption',
        );
        const evolutionChartSelectedPortfolio = immPortfolioEvolution.get(
            'selectedPortfolio',
        );
        const portfoliosEvolution = immGlobalPosition.get('portfolios');
        const evolutionChartModalData =
            immPortfolioEvolution.get('selectedPortfolio') === '0'
                ? immPortfolioEvolution.get('data') &&
                  immPortfolioEvolution.get('data').toJS()
                : immPortfolioEvolution.get('modalData') &&
                  immPortfolioEvolution.get('modalData').toJS();
        const isValidTest = isTestValid(immCheckStatus);
        const serviceBanner = hasRoboHired ? null : this.buildServiceBanner();
        const topRightWidget = this.buildTestInfo();
        const hireUrl = !immCheckStatus.get('newRoboCustomer')
            ? MANAGEMENT_PLAN_URL
            : RA_SUITABILITY_TEST_URL;
        const hireLink = hasRoboHired ? '' : hireUrl;
        const hasRoboCancelled = immPortfolioDistribution.get(
            'hasRoboCancelled',
        );
        const hasRoboPortfoliosCancelled =
            !!immPortfolioDistribution.getIn([
                'roboAdvisor',
                'portfolioOverviews',
            ]) &&
            immPortfolioDistribution
                .getIn(['roboAdvisor', 'portfolioOverviews'])
                .every(portfolio => portfolio.getIn(['state', 'cancelled']));
        const unsuitableTestBox =
            immFlagBasedFeatures.get('sign_suitability_test_not_suitable') &&
            immCheckStatus.get('nonSuitableTest') &&
            hasRoboPortfoliosCancelled
                ? this.buildUnsuitableTestCancelationBox()
                : null;
        const cancelledBox =
            hasRoboCancelled && hasRoboHired ? this.buildCancelledBox() : null;
        const immPortfolios = immGlobalPosition.get('portfolios');
        const portfolioSize = immPortfolios.size;
        const selectedPortfolio = immGlobalPosition.get('selectedPortfolio');
        const featureModal = this.buildFeatureModal();
        let summaryWidget;
        let distributionDetailsLink;
        let ordersAndMovementsLink;
        let distributionInfo;
        let investmentSpecialist;
        let saveMessage;
        const msgFlag = immGlobalPosition.get('saveSimulationLandingMessage');
        saveMessage =
            msgFlag && !immCheckStatus.get('nonSuitableTest')
                ? this.buildSaveSimulationMessage()
                : null;

        const isAllowed = immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST);
        const isExpiredTest = isTestExpired(immCheckStatus);
        const showTestExpiredAlert = isAllowed && isExpiredTest;

        const testExpiredModal = showTestExpiredAlert
            ? this.buildTestExpiredModal()
            : null;

        const testExpiredAlertForCC = __CONTACT_CENTER__ &&
            showTestExpiredAlert && (
                <BlockInfo extraClass="ra-suitability-test-success__block-info">
                    <FormattedText value="raGlobalPosition-raGlobalPosition_testExpiredTextForCC" />
                </BlockInfo>
            );
        if (immCheckStatus.get('newRoboCustomer') || portfolioSize === 0) {
            summaryWidget = this.buildSummaryWidgetEmptyState();
            distributionInfo = (
                <FormattedText
                    value="raGlobalPosition-raGlobalPosition_distributionInfo"
                    className="ra-global-position__section-subtitle"
                />
            );

            investmentSpecialist = (
                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                    <BrokerInvestmentSpecialist />
                </div>
            );
        } else {
            summaryWidget = (
                <RASummaryWidget
                    immGlobalPosition={immGlobalPosition}
                    onNewObjectiveClick={this.handleNewObjectiveClick}
                    onNewStrategyClick={this.handleNewStrategyClick}
                    immManagementPlan={immManagementPlan}
                    immSimulation={immSimulation}
                    immCustomPlanByObjective={
                        this.props.immCustomPlanByObjective
                    }
                    immSaveSimulation={this.props.immSaveSimulation}
                    isTestActive={isValidTest}
                    handleSaveGoalItemClick={this.onHandleSaveGoalItemClick}
                />
            );

            distributionDetailsLink = (
                <OKLink
                    modifier="emphasize"
                    onClick={this.handleOpenDistributionModal}
                >
                    <FormattedText value="raGlobalPosition-raGlobalPosition_showDistributionDetailsCTA" />
                </OKLink>
            );

            ordersAndMovementsLink = (
                <div className="ra-global-position__link--right">
                    <OKLink
                        to={RA_LAST_MOVEMENTS_URL}
                        onClick={this.handleOrdersAndMovementsrecordLink}
                        modifier="complementary"
                    >
                        <FormattedText value="raGlobalPosition-raGlobalPosition_goToOrdersAndMovements" />
                    </OKLink>
                </div>
            );
        }

        const anyPortfolioActive = !this.isAnyPortfolioActive();
        const newContributionsComponent = hasRoboHired
            ? this.buildNewContributionsComponent(
                  anyPortfolioActive,
                  immPortfolios,
              )
            : null;
        const evolutionDisabled =
            !hasRoboHired || evolutionChartData.length === 0;
        const evolutionModalDisabled =
            !hasRoboHired || evolutionChartModalData.length === 0;
        const portfoliosQuantity = immGlobalPosition.get('portfolios')
            ? immGlobalPosition.get('portfolios').size
            : DEFAULT_PORTFOLIO_QUANTITY;
        const distributionSubTitle = hasRoboHired
            ? formatText('raDistributionWidget-subtitle', [portfoliosQuantity])
            : null;

        const goalNotification =
            !__CONTACT_CENTER__ && this.state.showGoalNotification
                ? this.buildGoalNotification(immPortfolios)
                : null;
        const goalNotificationForCC = this.state
            .showGoalNotificationForContactCenter
            ? this.buildNotificationForCC()
            : null;

        const summaryWrapperClassName = classnames(
            'col-xs-12 col-sm-12 col-md-12',
            {
                'grid-view--fix-cell-separation': hasRoboHired,
                'grid-view--variable-cell-separation': !hasRoboHired,
            },
        );
        const headerActionButtons = hasRoboHired
            ? this.buildHeaderActionButtons(immCheckStatus, immGlobalPosition)
            : null;
        const fundTransferNotification =
            this.state.showFundTransferNotification &&
            this.buildFundTransferNotification();
        const guideLinkSection = this.buildGuideLinkSection();

        const menssageDescription = (
            <FormattedText value="raAlertsWidget-messageDescription" />
        );
        const linkTextForAlert = (
            <FormattedText value="raAlertsWidget-linkText" />
        );
        const menssage = new Map();
        menssage.set('message', menssageDescription);
        let immRAAlertsPoe = new Map();
        immRAAlertsPoe.set('alerts', [menssage]);
        immRAAlertsPoe.set('error', null);
        immRAAlertsPoe.set('isFetching', false);

        const originCountry = immProfile.get('originCountry');
        const url =
            originCountry === ORIGIN_COUNTRY_GERMANY
                ? formatText('raAlertsWidget-urDelLink')
                : formatText('raAlertsWidget-urlLink');
        const ffPutYourMoneyToWork = immFlagBasedFeatures.get(
            PUT_YOUR_MONEY_TO_WORK,
        );
        return (
            <div className="container-fluid">
                {testExpiredModal}
                <RANonresidentialModal
                    showModal={this.state.showModal}
                    title={this.state.modalTitle}
                    closeModal={this.handleToggleModal} // eslint-disable-line
                    message={formatText('raNonresidentialModal-description')}
                    button={formatText('raNonresidentialModal-button')}
                    number={RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER}
                />
                <ContactCenterRender>
                    {goalNotificationForCC}
                    {testExpiredAlertForCC}
                    <RAErrorFetchingCountryOfResidenceModal
                        showModal={
                            this.state.showErrorFetchingCountryOfResidenceModal
                        }
                        title={formatText(
                            'raErrorFetchingCountryOfResidenceModal-title',
                        )}
                        closeModal={
                            this
                                .handleToggleErrorFetchingCountryOfResidenceModal
                        }
                        message={formatText(
                            'raErrorFetchingCountryOfResidenceModal-description',
                        )}
                        button={formatText(
                            'raErrorFetchingCountryOfResidenceModal-button',
                        )}
                    />
                </ContactCenterRender>
                <div className="row">
                    <div className="col-md-12 ra-global-position__notifications-box">
                        {unsuitableTestBox}
                    </div>
                    <div className="col-md-12 ra-global-position__notifications-box">
                        {cancelledBox}
                    </div>
                    <div className="col-md-12 ra-global-position__notifications-box">
                        {fundTransferNotification}
                    </div>
                    <div className="col-md-12 ra-global-position__notifications-box">
                        {goalNotification}
                    </div>
                    <div className="col-md-12 ra-global-position__notifications-box">
                        {saveMessage}
                    </div>
                    <div className="col-xs-12 col-md-8">
                        <div className="row">
                            {serviceBanner}
                            <div className="col-md-12">
                                <RADistributionWidget
                                    hasRoboHired={hasRoboHired}
                                    immRoboAdvisor={immRoboAdvisor}
                                    link={hireLink}
                                    distributionInfo={formatText(
                                        'raDistributionWidget-info',
                                    )}
                                    distributionTitle={formatText(
                                        'raDistributionWidget-title',
                                    )}
                                    distributionSubTitle={distributionSubTitle}
                                    validateResidential={link =>
                                        this.validateResidential(link)
                                    }
                                    number={
                                        RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER
                                    }
                                    showProfitabilityTooltip={false}
                                    calculateLinkClick={
                                        this.onCalculateLinkClick
                                    }
                                />
                            </div>
                            <div className="col-md-12 grid-view--fix-cell-separation">
                                <RAModalContainer
                                    link={hireLink}
                                    validateResidential={link =>
                                        this.validateResidential(link)
                                    }
                                >
                                    <RAPortfolioEvolution
                                        immGlobalPosition={immGlobalPosition}
                                        data={evolutionChartData}
                                        modalData={evolutionChartModalData}
                                        selectedOption={
                                            evolutionChartSelectedOption
                                        }
                                        selectedPortfolio={
                                            evolutionChartSelectedPortfolio
                                        }
                                        changeModalOption={
                                            this
                                                .handleEvolutionChartModalOptionChange
                                        }
                                        portfoliosEvolution={
                                            portfoliosEvolution
                                        }
                                        disabled={evolutionDisabled}
                                        loading={evolutionChartLoading}
                                        modalDisabled={evolutionModalDisabled}
                                        title={formatText(
                                            'raPortfolioEvolution-raPortfolioEvolution_title',
                                        )}
                                        description={formatText(
                                            'raPortfolioEvolution-raPortfolioEvolution_subtitle',
                                        )}
                                        evolutionLink={formatText(
                                            'raPortfolioEvolution-raPortfolioEvolution_link',
                                        )}
                                        showLink={hasRoboHired}
                                        hasRoboNotHired={!hasRoboHired}
                                        onEmptyEvolutionLinkClick={
                                            this.handleEmptyEvolutionLinkClick
                                        }
                                    />
                                </RAModalContainer>
                            </div>
                            {newContributionsComponent}
                            {ffPutYourMoneyToWork && (
                                <div className="col-md-12 grid-view--fix-cell-separation">
                                    <CommercialAds
                                        path="broker/general/robo"
                                        type="banner-c"
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-4">
                        <div className="row">
                            {headerActionButtons}
                            <div className={summaryWrapperClassName}>
                                {summaryWidget}
                                {featureModal}
                            </div>
                            {guideLinkSection}
                            <div className="col-xs-12 col-sm-12 col-md-12 grid-view--fix-cell-separation">
                                {topRightWidget}
                            </div>
                            {investmentSpecialist}
                            <FeatureTogglingRender
                                notAllowedProductKey={ALERTS}
                            >
                                <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                                    <RAAlertsWidget
                                        fetchAlerts={fetchAlerts}
                                        immAlertsData={immRAAlertsPoe}
                                        isInfoFromPoe={true}
                                        textLink={linkTextForAlert}
                                        url={url}
                                        linkTaggingEvent={() =>
                                            taggingEventHandled(
                                                RA_GLOBAL_POSITION,
                                                'alert_widget_link',
                                            )
                                        }
                                    />
                                </div>
                            </FeatureTogglingRender>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-12 grid-view--fix-cell-separation">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ra-global-position__section-table">
                                    <div className="ra-global-position__header-table-section">
                                        <h2 className="ra-global-position__section-title">
                                            <FormattedText value="raGlobalPosition-raGlobalPosition_distributionSectionTitle" />
                                        </h2>
                                        <div className="ra-global-position__section-subtitle">
                                            <FormattedText
                                                value="raGlobalPosition-raGlobalPosition_distributionSubtitle"
                                                injectedStrings={[
                                                    portfolioSize,
                                                ]}
                                                className="ra-global-position__section-info"
                                            />
                                            {distributionDetailsLink}
                                        </div>
                                        {distributionInfo}
                                    </div>
                                    <FeatureTogglingRender
                                        notAllowedProductKey={ESG_PRODUCT}
                                    >
                                        <div className="ra-global-position__section-esg-tag">
                                            <i className="ra-global-position__section-esg-icon" />
                                            <FormattedText value="raGlobalPosition-raGlobalPosition_esgTag" />
                                        </div>
                                    </FeatureTogglingRender>
                                    <RAAccordionDistributionTable
                                        immKeyFigures={immRoboAdvisor.get(
                                            'totals',
                                        )}
                                        immAssetAllocations={
                                            immAssetAllocations
                                        }
                                        // eslint-disable-next-line react/jsx-handler-names
                                        onAccordionRecordLinkClick={
                                            this
                                                .handleAccordionDistributionTableLink
                                        }
                                    />
                                    <RADistributionModal
                                        isOpen={
                                            this.state.isDistributionModalOpened
                                        }
                                        onCloseModal={
                                            this.handleCloseDistributionModal
                                        }
                                        immAssetAllocations={
                                            immAssetAllocations
                                        }
                                        immPortfolios={immPortfolios}
                                        immRoboAdvisor={immRoboAdvisor}
                                        onDistributionModalOptionChange={
                                            this.handleModalOptionChange
                                        }
                                        selectedPortfolio={selectedPortfolio}
                                    />
                                </div>
                            </div>
                        </div>
                        {ordersAndMovementsLink}
                    </div>
                </div>
            </div>
        );
    }
}

RAGlobalPosition.propTypes = {
    evolutionChartChangeModalOption: PropTypes.func.isRequired,
    evolutionChartChangeOption: PropTypes.func.isRequired,
    featureModalToggle: PropTypes.func.isRequired,
    fetchAlerts: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    getHistoricalTest: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAdditionalContribution: PropTypes.object.isRequired,
    immBrokerCustomWalletPortfolios: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    immCustomPlanByObjective: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immPortfolioDistribution: PropTypes.object.isRequired,
    immPortfolioEvolution: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immRAAlerts: PropTypes.object.isRequired,
    immRAFeatureFlag: PropTypes.object.isRequired,
    immSaveSimulation: PropTypes.object.isRequired,
    immSimulation: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    consultMiFID: PropTypes.func.isRequired,
    requestPortfolioEvolution: PropTypes.func.isRequired,
    requestPortfolioEvolutionTotals: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    requestSaveSimulationLandingMessage: PropTypes.func.isRequired,
    requestSimulationObjective: PropTypes.func.isRequired,
    requestSimulationPortfolio: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func.isRequired,
    setAdditionalContributionAmount: PropTypes.func.isRequired,
    setEditClicked: PropTypes.func.isRequired,
    setFromPGNotification: PropTypes.func.isRequired,
    setOrigin: PropTypes.func.isRequired,
    setOriginRedirection: PropTypes.func.isRequired,
    setSelectedPortfolio: PropTypes.func.isRequired,
    setSinglePortfolioNotificationClosed: PropTypes.func.isRequired,
    setSinglePortfolioNotificationDisabled: PropTypes.func.isRequired,
    showBrokerGeneralError: PropTypes.func.isRequired,
    immBrokerCustomWalletInvestments: PropTypes.object.isRequired,
    immWalletCharts: PropTypes.object.isRequired,
    immRAGlobalPosition: PropTypes.object.isRequired,
};

module.exports = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAdditionalContribution: state.raAdditionalContribution,
        immCheckStatus: state.raCheckStatus,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
        immBrokerCustomWalletPortfolios: state.brokerCustomWalletPortfolios,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immRAFeatureFlag: state.raFeatureFlag,
        immGlobalPosition: state.raGlobalPosition,
        immManagementPlan: state.raManagementPlan,
        immPortfolioDistribution: state.raPortfolioDistribution,
        immPortfolioEvolution: state.raPortfolioEvolution,
        immProfile: state.profile,
        immRAAlerts: state.raAlertsReducer,
        immSimulation: state.raSimulation,
        immSaveSimulation: state.raSaveSimulation,
        immSuitabilityTest: state.raSuitabilityTest,
        immBrokerCustomWalletInvestments: state.brokerCustomWalletInvestments,
        immWalletCharts: state.myWalletCharts,
        immVariables: state.globalVariables.getIn([
            'variables',
            'parameters',
            'contratos',
        ]),
        immRAGlobalPosition: state.raGlobalPosition,
    }),
    {
        consultMiFID: BrokerConsultMiFIDActions.consultMiFID,
        evolutionChartChangeModalOption:
            portfolioEvolutionActions.portfolioEvolutionChangeModalOption,
        evolutionChartChangeOption:
            portfolioEvolutionActions.portfolioEvolutionChangeOption,
        featureModalToggle: RAFeatureFlagActions.featureModalToggle,
        fetchAlerts: RAAlertsActions.fetchAlerts,
        getHistoricalTest: suitabilityActions.getHistoricalTest,
        getTestResult: suitabilityActions.getTestResult,
        requestPortfolioEvolution:
            portfolioEvolutionActions.requestPortfolioEvolution,
        requestPortfolioEvolutionTotals:
            portfolioEvolutionActions.requestPortfolioEvolutionTotals,
        requestSimulationPortfolio: raSaveSimulationActions.requestSimulation,
        requestSimulationObjective: raSaveSimulationActions.requestSimulation,
        requestSaveSimulationLandingMessage:
            raGlobalPosition.requestSaveSimulationLandingMessage,
        setAdditionalContributionAmount:
            raAdditionalContributionActions.setAdditionalContributionAmount,
        setEditClicked: raManagementPlanActions.setEditClicked,
        setFromPGNotification: raObjectiveDetailsActions.setFromPGNotification,
        setOrigin: suitabilityActions.setOrigin,
        setOriginRedirection: raGlobalPosition.setOriginRedirection,
        setSelectedPortfolio: raGlobalPosition.setSelectedPortfolio,
        setSinglePortfolioNotificationClosed:
            raGlobalPosition.setSinglePortfolioNotificationClosed,
        setSinglePortfolioNotificationDisabled:
            raGlobalPosition.setSinglePortfolioNotificationDisabled,
        showBrokerGeneralError: raErrorHandlerActions.show,
        requestProfile: profileActions.requestProfile,
        resetSpecificProduct:
            BrokerProductFiltersSearchActions.resetSpecificProduct,
    },
)(withRouter(RAGlobalPosition));
